import clsx from 'clsx';
import { Avatar, isChannel, useChatContext } from 'stream-chat-react';

import type { Channel, UserResponse } from 'stream-chat';

import { channelByUser, ChannelOrUserType, CustomChannelData } from './ChatUtils';
import { useTranslation } from 'react-i18next';

type SearchResultProps = Pick<ResultsDropdownProps, 'focusedId' | 'setChannel'> & {
  result: ChannelOrUserType;
};

const SearchResult = (props: SearchResultProps) => {
  const { focusedId, result, setChannel } = props;

  const { client, setActiveChannel } = useChatContext();

  if (isChannel(result)) {
    const channel = result;

    return (
      <div
        onClick={() => setChannel(channel)}
        className={clsx('channel-search__result-container', { highlighted: focusedId === channel.id })}
      >
        <div className="result-hashtag"></div>
        <p className="channel-search__result-text">{(channel?.data as CustomChannelData)?.name}</p>
      </div>
    );
  } else {
    const user = result;

    return (
      <div
        onClick={async () => {
          await channelByUser({ client, setActiveChannel, user });
        }}
        className={clsx('channel-search__result-container', { highlighted: focusedId === user.id })}
      >
        <Avatar image={user.image} name={user.name || user.id} />
        <p className="channel-search__result-text">{user.name || user.id || 'Johnny Blaze'}</p>
      </div>
    );
  }
};

type ResultsDropdownProps = {
  teamChannels?: Channel[];
  directChannels?: UserResponse[];
  focusedId: string;
  loading: boolean;
  setChannel: (channel: Channel) => void;
};

export const ResultsDropdown = (props: ResultsDropdownProps) => {
  const { teamChannels, focusedId, loading, setChannel } = props;
  const { t } = useTranslation();

  return (
    <div className="channel-search__results">
      <p className="channel-search__results-header">{t('streamChat.custom.channels')}</p>
      {loading && !teamChannels?.length && (
        <p className="channel-search__results-header">
          <i>{t('streamChat.custom.loading')}</i>
        </p>
      )}
      {!loading && !teamChannels?.length ? (
        <p className="channel-search__results-header">
          <i>{t('streamChat.custom.notmemberYet')}</i>
        </p>
      ) : (
        teamChannels?.map((channel) => (
          <SearchResult result={channel} focusedId={focusedId} key={channel.id} setChannel={setChannel} />
        ))
      )}
      {/* <p className='channel-search__results-header'>Users</p>
      {loading && !directChannels?.length && (
        <p className='channel-search__results-header'>
          <i>Loading...</i>
        </p>
      )} */}
      {/* {!loading && !directChannels?.length ? (
        <p className='channel-search__results-header'>
          <i>No direct messages found</i>
        </p>
      ) : (
        directChannels?.map((user: UserResponse, i) => (
          <SearchResult result={user} focusedId={focusedId} key={i} setChannel={setChannel} />
        ))
      )} */}
    </div>
  );
};
